import React, { useState } from 'react'
import { FaMicrochip } from 'react-icons/fa'
import '../Tools.css'

const CapacitorCalculator = () => {
    const [code, setCode] = useState('104')

    const calculateCapacitance = () => {
        if (code.length < 2 || code.length > 3) return null

        const codeStr = code.toString()
        if (codeStr.length === 3) {
            const digits = parseInt(codeStr.slice(0, 2))
            const multiplier = parseInt(codeStr[2])
            const picofarads = digits * Math.pow(10, multiplier)
            return picofarads
        } else if (codeStr.length === 2) {
            return parseInt(codeStr)
        }
        return null
    }

    const formatCapacitance = (pf) => {
        if (pf === null) return 'Invalid code'
        if (pf >= 1000000) {
            return `${(pf / 1000000).toFixed(2)} \u00B5F`
        } else if (pf >= 1000) {
            return `${(pf / 1000).toFixed(2)} nF`
        }
        return `${pf} pF`
    }

    const capacitance = calculateCapacitance()

    return (
        <div className="tool-calculator">
            <h3><FaMicrochip /> Capacitor Code Calculator</h3>
            <p className="tool-description">Enter the 3-digit capacitor code to find its value. The first two digits are significant figures, the third is the multiplier (number of zeros).</p>

            <div className="capacitor-input">
                <div className="input-group">
                    <label>Capacitor Code</label>
                    <input
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 3))}
                        placeholder="104"
                        maxLength="3"
                    />
                </div>
            </div>

            <div className="code-explanation">
                <p><strong>Common codes:</strong></p>
                <ul>
                    <li>104 = 100,000 pF = 100 nF = 0.1 &mu;F</li>
                    <li>103 = 10,000 pF = 10 nF = 0.01 &mu;F</li>
                    <li>102 = 1,000 pF = 1 nF</li>
                    <li>101 = 100 pF</li>
                    <li>100 = 10 pF</li>
                </ul>
            </div>

            <div className="result-box">
                <div className="result-row">
                    <span className="result-label">Capacitance:</span>
                    <span className="result-value">{formatCapacitance(capacitance)}</span>
                </div>
                {capacitance && (
                    <>
                        <div className="result-row">
                            <span className="result-label">In picofarads:</span>
                            <span className="result-value">{capacitance.toLocaleString()} pF</span>
                        </div>
                        {capacitance >= 1000 && (
                            <div className="result-row">
                                <span className="result-label">In nanofarads:</span>
                                <span className="result-value">{(capacitance / 1000).toFixed(3)} nF</span>
                            </div>
                        )}
                        {capacitance >= 1000000 && (
                            <div className="result-row">
                                <span className="result-label">In microfarads:</span>
                                <span className="result-value">{(capacitance / 1000000).toFixed(6)} &mu;F</span>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default CapacitorCalculator
